module.exports = __webpack_public_path__ + "static/media/therooms-logo.df1ad709.jpg";